import Chatbot from '@components/Chatbot';
import Matomo from '@components/Matomo';
import Script from 'next/script';
import React from 'react';

const CustomScripts = () => {
  return (
    <>
      <Matomo />
      <Chatbot />

      <Script
        async
        src={`https://cdn.eye-able.com/configs/${process.env.NEXT_PUBLIC_BASE_URL?.replace(
          'https://',
          '',
        )}.js`}
      />
      <Script async src="https://cdn.eye-able.com/public/js/eyeAble.js" />
    </>
  );
};

export default CustomScripts;
